module.exports = __webpack_public_path__ + "img/fake-popup-MB-2-2.b64c5e04.png";